<template>
  <!-- eslint-disable max-len -->
  <BaseCard
    :id="`exp-${name}`"
    ref="card"
    class="card exp-card"
    :title="name"
    clickable
    @edit-mode="(mode) => editTitle = mode"
    @apply-edit="handleApplyEdit"
  >
    <template #header>
      <BaseMenu
        :placement="'bottom-start'"
        @closed="show_menu = false"
      >
        <IconButton
          v-model="show_menu"
          class="refresh-icon"
          :icon="'more_vert'"
          :width="22"
          :height="22"
        />
        <template #menu="{closeMenu}">
          <ul>
            <li>
              <BaseMenuButton v-tooltip="'Edit experiment information'" @click.stop="handleApplyEdit(), closeMenu()">
                <SVGIcon
                  :iconName="'edit'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Edit</span>
              </BaseMenuButton>
            </li>
            <li>
              <BaseMenuButton v-tooltip="'View all training sessions'" @click.stop="handleTrainClickEvent(), closeMenu()">
                <SVGIcon
                  :iconName="'train'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Training Sessions</span>
              </BaseMenuButton>
            </li>
            <li>
              <BaseMenuButton v-tooltip="'View all validate sessions'" @click.stop="handleValClickEvent(), closeMenu()">
                <SVGIcon
                  :iconName="'compare'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Validate Sessions</span>
              </BaseMenuButton>
            </li>

            <li>
              <BaseMenuButton v-tooltip="'Move experiment to Recycle Bin'" class="_danger" @click.stop="deleteExperiment(), closeMenu()">
                <SVGIcon
                  :iconName="'trash'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Move to Recycle Bin</span>
              </BaseMenuButton>
            </li>
          </ul>
        </template>
      </BaseMenu>
    </template>
    <template #body>
     
      <div class="project-rows">
        <div class="bar" />

        <div class="box-rows-container">
          <div :class="`${name}-training-sessions-btn training-sessions-btn`" class="session-row" @click="handleTrainClickEvent">
            <div class="d-flex mb-1 w-100 justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <SVGIcon
                  :iconName="'train'"
                  :width="'32px'"
                  :height="'32px'"
                  class="primary-icon-color"
                />
                <span class="ml-2">Training Sessions</span>
              </div>

              <SVGIcon
                :iconName="'chevron_right'"
                :width="'24px'"
                :height="'24px'"
                class="primary-icon-color"
              />
            </div>
            <div class="card-detail-box-row">
              <template v-if="hasTrainingSessions">
                <div v-if="complete > 0" v-tooltip="'Completed training sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _complete">
                      <SVGIcon
                        :iconName="'check_circle'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ complete }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="running > 0" v-tooltip="'Running training sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _running">
                      <SVGIcon
                        :iconName="'ellipsis'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ running }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="terminated > 0" v-tooltip="'Terminated training sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _warning">
                      <SVGIcon
                        :iconName="'warning'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ terminated }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="errors > 0" v-tooltip="'Error training sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _error">
                      <SVGIcon
                        :iconName="'close_circle'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ errors }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="no-sessions-message">No Sessions</div>
            </div>
          </div>
          <div :class="`${name}-validate-sessions-btn validate-sessions-btn`" class="session-row" @click="handleValClickEvent">
            <div class="d-flex mb-1 w-100 justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <SVGIcon
                  :iconName="'compare'"
                  :width="'32px'"
                  :height="'32px'"
                  class="primary-icon-color"
                />
                <span class="ml-2">Validate Sessions</span>
              </div>
              <SVGIcon
                :iconName="'chevron_right'"
                :width="'24px'"
                :height="'24px'"
                class="primary-icon-color"
              />
            </div>
            <div class="card-detail-box-row">
              <template v-if="hasValidationSessions">
                <div v-if="valCompleted > 0" v-tooltip="'Completed validation sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _complete">
                      <SVGIcon
                        :iconName="'check_circle'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ valCompleted }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="valRunning > 0" v-tooltip="'Running validation sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _running">
                      <SVGIcon
                        :iconName="'ellipsis'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ valRunning }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="valTerminated > 0" v-tooltip="'Terminated validation sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _warning">
                      <SVGIcon
                        :iconName="'warning'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ valTerminated }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="valError > 0" v-tooltip="'Error validation sessions'" class="card-detail-box">
                  <div class="card-detail-box__badge">
                    <div class="card-detail-box__icon _error">
                      <SVGIcon
                        :iconName="'close_circle'"
                        :width="'26px'"
                        :height="'26px'"
                      />
                    </div>
                    <div class="card-detail-box__details">
                      <span class="card-detail-box__details-value">{{ valError }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="no-sessions-message">No Sessions</div>
            </div>
          </div>
        </div>
     
     <EncodedIdField
        :id="id"
        :single-line="true"
        :type="'experiment'"
      />
       
      </div>
     
    </template>
    <template #footer>
      
    
     <DescriptionField
        :text="description"
        :clickable="true"
        @click="handleApplyEdit"
      />
       </template>
      
  </BaseCard>
</template>

<script>
import BaseCard from '@/components/BaseCard.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import IconButton from '@/components/IconButton.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import BaseTextExpander from '@/components/BaseTextExpander.vue';
import EncodedIdField from '@/components/EncodedIdField.vue';
import DescriptionField from '@/components/utils/DescriptionField.vue';

export default {
  components: {
    BaseCard,
    BaseMenuButton,
    IconButton,
    SVGIcon,
    BaseMenu,
    BaseTextExpander,
    EncodedIdField,
    DescriptionField,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: 0,
    },
    running: {
      type: Number,
      default: 0,
    },
    errors: {
      type: Number,
      default: 0,
    },
    complete: {
      type: Number,
      default: 0,
    },
    terminated: {
      type: Number,
      default: 0,
    },
    valRunning: {
      type: Number,
      default: 0,
    },
    valError: {
      type: Number,
      default: 0,
    },
    valCompleted: {
      type: Number,
      default: 0,
    },
    valTerminated: {
      type: Number,
      default: 0,
    },
  },
  emits: ['delete-experiment', 'train-clicked', 'val-clicked', 'edit-experiment'],

  data() {
    return {
      show_menu: false,
    };
  },
  computed: {
    hasTrainingSessions() {
      return this.complete > 0 || this.running > 0 || this.terminated > 0 || this.errors > 0;
    },
    hasValidationSessions() {
      return this.valCompleted > 0 || this.valRunning > 0 || this.valTerminated > 0 || this.valError > 0;
    },
  },
  methods: {
    deleteExperiment() {
      this.$emit('delete-experiment');
    },
    handleTrainClickEvent() {
      this.$emit('train-clicked');
    },
    handleValClickEvent() {
      this.$emit('val-clicked');
    },
    handleApplyEdit() {
      this.$emit('edit-experiment');
    },

  },
};
</script>

<style lang="scss" scoped>

.bar {
  width: 100%;
  height: 3px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: var(--color-primary);
}

.exp-card {
  min-width: 300px;
  max-width: 500px;
  height: 100%;
  cursor: default !important;

  &:hover {
    transform: none !important;
  }
}

.project-rows {
  display: flex;
  flex-direction: column;
  flex: 1;
}

$badge-height: 44px;
$badge-padding: 5px;

.box-rows-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  gap: 10px;
}

.session-row {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: fit-content;
  padding: 10px;
  margin: 0px;
  border-radius: 4px;
  box-shadow: 2px 2px 4px 2px rgba(0, 0, 0, 0.125), 0 0 2px 1px rgba(0, 0, 0, 0.25);

  &:hover {
    cursor: pointer;
    background: rgba(140,140,140,0.2)
  }

  span {
    font-weight: 600;
    font-size: 0.875rem;
  }
}

.card-detail-box-row {
  display: flex;
  flex-direction: row;
  min-height: $badge-height;
  max-height: $badge-height;
  width: 100%;
  gap: 10px;
}

.no-sessions-message {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: $badge-height;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.5);
  @include themify() {
    color: themed('color-text-secondary');
  }
}

.card-detail-box {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 80px;
  border: 1px solid rgba(0,0,0,0.075);
  border-radius: 4px;
  overflow: hidden;
  @include themify() {
    background: themed('color-white-600');
  }

  &__badge {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: $badge-height - 2px;
    width: 100%;
    padding: $badge-padding;

    &._bottom-border {
      border-bottom: 1px solid rgba(0, 0, 0, 0.075);
    }
  }

  &__icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    min-width: $badge-height - ($badge-padding * 2) - 2px;
    height: 100%;

    &._complete {
    @include themify() {
      color: themed('color-status-complete');
    }
  }
  &._running {
    @include themify() {
      color: themed('color-status-running');
    }
  }
  &._error {
    @include themify() {
      color: themed('color-status-error');
    }
  }

  &._warning {
    @include themify() {
      color: themed('color-status-warning');
    }
  }
  }

  &__details {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
  }

  &__details-title {
    line-height: 1;
    font-weight: 500;
    @include themify() {
      font-size: 0.75rem;
      color: themed('body-text-color-secondary');
    }
  }

  &__details-value {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @include themify() {
      font-size: 1rem;
      color: themed('body-text-color');
    }
  }

  &__icon-container {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
    @include themify() {
      color: themed('body-text-color-secondary');
    }
  }

  &._groups {
    max-height: 130px;
    flex: 1 0 min-content;
  }
}

.primary-icon-color {
  color: var(--color-primary);
}

  </style>
